import throttle from 'lodash/throttle';

export function init() {
    sticky();
    window.addEventListener('scroll', checkSticky);
}

var checkSticky = throttle(() => {
    sticky();
}, 300);

var sticky = function () {
    let scrollPosition = Math.round(window.pageYOffset);

    if (scrollPosition > 100 && document.querySelector('header')) {
        document.querySelector('header').classList.add('header--sticky');
    } else {
        if (document.querySelector('header') && document.querySelector('header').classList.contains('header--sticky')) {
            document.querySelector('header').classList.remove('header--sticky');
        }
    }
};
